
import request from '@/http/request'
 
// 登录方法
export function login(username, password, code, uuid) {
    const data = {
      username,
      password,
      code,
      uuid
    }
    return request({
      url: '/login',
      headers: {
        isToken: false,
        repeatSubmit: false
      },
      method: 'post',
      data: data
    })
  }
  
  // 注册方法
  export function register(data) {
    return request({
      url: '/system/audit',
      method: 'post',
      data: data
    })
  }
  
  // 获取用户详细信息
  export function getInfo() {
    return request({
      url: '/getMyUserInfo',
      method: 'get'
    })
  }
  
  // 退出方法
  export function logout() {
    return request({
      url: '/logout',
      method: 'post'
    })
  }
  
  // 获取验证码
  export function getCodeImg() {
    return request({
      url: '/captchaImage',
      headers: {
        isToken: false
      },
      method: 'get',
      timeout: 20000
    })
  }
  
   // 更新用户头像
   export function uploadAvatar(data) {
    return request({
      url: '/system/user/profile/avatar',
      method: 'post',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: data
    })
  }

  // 发送重置密码验证码
  export function sendResetCode(email) {
    return request({
      url: '/system/resetPassword/sendCode',
      headers: {
        isToken: false
      },
      method: 'post',
      data: { email }
    })
  }

  // 验证重置密码验证码
  export function validateResetCode(email, code) {
    return request({
      url: '/system/resetPassword/validateCode',
      headers: {
        isToken: false
      },
      method: 'post',
      data: { email, code }
    })
  }

  // 重置密码
  export function resetPassword(email, code, newPassword) {
    return request({
      url: '/system/resetPassword/reset',
      headers: {
        isToken: false
      },
      method: 'post',
      data: { email, code, newPassword }
    })
  }
  